import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=23ffbe39&scoped=true&"
import script from "./SidebarLink.vue?vue&type=script&lang=js&"
export * from "./SidebarLink.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLink.vue?vue&type=style&index=0&id=23ffbe39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ffbe39",
  null
  
)

export default component.exports